import { useCallback, useState } from 'react';

export function useModal(openInitially = false) {
  const [isOpen, setOpen] = useState(openInitially);
  const showModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  return [isOpen, showModal, closeModal];
}
